/**
 * Seller subscriptions.
 *
 * Bespoke Threads: every seller can open /subscription (existing).
 * OmniCommerce: enterprise admins can edit plans in Settings. The seller
 * page is limited to one account so Shopify App Store reviewers, and every
 * other new or existing seller, never see plan cards or billing.
 */

export const OMNICOMMERCE_SELLER_SUBSCRIPTION_EMAIL =
  "zia@crossfitcounterculture.com";

export const normalizeSellerEmail = (email) =>
  String(email || "").trim().toLowerCase();

export const isAllowlistedOmniSellerSubscriptionEmail = (email) =>
  normalizeSellerEmail(email) === OMNICOMMERCE_SELLER_SUBSCRIPTION_EMAIL;

/** Settings → Pricing → Seller subscriptions. */
export const canEditSellerSubscriptions = ({
  isBespokeDomain,
  isOmniCommerce,
  isEnterpriseAdmin,
} = {}) => {
  if (!isEnterpriseAdmin) return false;
  return !!(isBespokeDomain || isOmniCommerce);
};

/**
 * Seller-facing /subscription page.
 * Pass isBespokeDomain only for the page gate. The OmniCommerce nav item
 * should pass false so Bespoke does not gain a new rail row.
 */
export const canSeeSellerSubscriptionPlans = ({
  isBespokeDomain,
  isOmniCommerce,
  email,
} = {}) => {
  if (isBespokeDomain) return true;
  if (!isOmniCommerce) return false;
  return isAllowlistedOmniSellerSubscriptionEmail(email);
};
